import {
  BrowserAuthError,
  ClientAuthError,
  InteractionRequiredAuthError,
  ServerError,
} from '@azure/msal-browser';
import type { AuthTokens } from '@data';
import {
  AdminConsentRequiredError,
  getAuthenticationScopes,
  handleError,
  logError,
  logInfo,
  PopupAuthError,
  TokenAcquisitionError,
} from '@utils-global';
import { OfficeAccountManager } from './accountManager';

type AuthenticateWithNAAParams = {
  isSharedMailbox: boolean;
  interactive: boolean;
  showToast: (translationKey: string) => void;
};

export const authenticateWithNAA = async ({
  isSharedMailbox,
  interactive,
  showToast,
}: AuthenticateWithNAAParams): Promise<AuthTokens | null> => {
  try {
    const accountManager = new OfficeAccountManager();

    await accountManager.initialize();
    const identity = await accountManager.ssoGetUserIdentity(
      getAuthenticationScopes(isSharedMailbox),
      interactive,
    );

    if (!identity) {
      return null;
    }

    return {
      graphToken: identity.accessToken,
      idToken: identity.idToken,
    };
  } catch (error) {
    if (error instanceof AdminConsentRequiredError) {
      showToast('errors.adminConsentRequired');
      return null;
    }

    if (error instanceof PopupAuthError) {
      logInfo('NAA popup blocked - user will use login button');
      return null;
    }

    if (
      error instanceof BrowserAuthError ||
      error instanceof ClientAuthError ||
      error instanceof ServerError ||
      error instanceof InteractionRequiredAuthError ||
      error instanceof TokenAcquisitionError
    ) {
      logError('NAA authentication failed', error);
      return null;
    }

    handleError(error);
    return null;
  }
};
